import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Application } from '../../../model/Application';
import { HttpResponse } from '../../../model/HttpResponse';
import { QueryOptionDto } from '../../../model/QueryOptionDto';
import { Transfer } from '../../../model/transfer/Transfer';
import { Renewal } from '../../../model/renewal/Renewal';
import { ApplicationService } from '../../../services/application.service';
import { PageHeaderComponent } from '../../shared/page-header/page-header.component';
import { SolicitudFormComponent } from './solicitud-form/solicitud-form.component';
import { SolicitudReviewComponent } from './solicitud-review/solicitud-review.component';
import { SolicitudesTableComponent } from './solicitudes-table/solicitudes-table.component';
import { TransferReviewComponent } from './transfer-review/transfer-review.component';
import { RenewalReviewComponent } from './renewal-review/renewal-review.component';

@Component({
  selector: 'app-solicitudes',
  standalone: true,
  templateUrl: './solicitudes.component.html',
  styleUrl: './solicitudes.component.scss',
  imports: [
    PageHeaderComponent,
    SolicitudesTableComponent,
    CommonModule,
    SolicitudReviewComponent,
    SolicitudFormComponent,
    TransferReviewComponent,
    RenewalReviewComponent,
  ],
})
export class SolicitudesComponent implements OnInit {
  applications: Application[] = [];
  showApplicationTable: boolean = true;
  showApplicationReview: boolean = false;
  applicationToReview: Application | any = {};
  transferToReview: Transfer | any = {};
  showTransferReviw: boolean = false;
  renewalToReview: Renewal | any = {};
  showRenewalReview: boolean = false;
  showApplicationForm: boolean = false;
  applicationToEdit: Application | any = {};
  tableState: {viewSelected?: string, filters?: any} = {};
  constructor(private applicationService: ApplicationService) {}
  ngOnInit(): void {
    this.getApplications();
  }

  getApplications() {
    const queryOptions: QueryOptionDto = {
      options: {
        conditionals: [
          {
            conditionalConnector: 'AND',
            evaluatedProperty: 'process.processStage',
            logicOperator: '<>',
            parameterName: '@Canceled',
            parameterValue: 'canceled',
          },
          {
            conditionalConnector: 'AND',
            evaluatedProperty: 'process.processStage',
            logicOperator: '<>',
            parameterName: '@Approved',
            parameterValue: 'approved',
          },
          {
            conditionalConnector: 'AND',
            evaluatedProperty: 'process.processStage',
            logicOperator: '<>',
            parameterName: '@Rejected',
            parameterValue: 'rejected',
          },
          {
            conditionalConnector: 'AND',
            evaluatedProperty: 'process.processStage',
            logicOperator: '<>',
            parameterName: '@Finished',
            parameterValue: 'finished',
          },
        ],
      },
    };
    this.applicationService
      .getApplications(queryOptions)
      .subscribe((res: HttpResponse) => {
        this.applications = res.response || [];
        this.showApplicationTable = true;
      });
  }

  reviewApplication(application: Application) {
    this.applicationService
      .getApplicationById(application.id!)
      .subscribe((res: HttpResponse) => {
        this.showApplicationTable = false;
        this.showApplicationReview = true;
        this.applicationToReview = res.response as Application;
      });
  }

  reviewTransfer(transfer: Transfer) {
    this.showApplicationReview = false;
    this.showApplicationTable = false;
    this.transferToReview = transfer;
    this.showTransferReviw = true;
  }

  reviewRenewal(renewal: Renewal) {
    this.showApplicationReview = false;
    this.showApplicationTable = false;
    this.showTransferReviw = false;
    this.renewalToReview = renewal;
    this.showRenewalReview = true;
  }

  editApplication(application: Application) {
    this.applicationToEdit = application;
    this.showApplicationTable = false;
    this.showApplicationReview = false;
    this.showApplicationForm = true;
  }

  quitOfRewiew(event: boolean) {
    if (event) {
      this.showTransferReviw = false;
      this.transferToReview = {};
      this.showApplicationReview = false;
      this.applicationToReview = {};
      this.showRenewalReview = false;
      this.renewalToReview = {};
      this.showApplicationTable = true;
    }
  }

  quitOfForm(event: boolean) {
    if (event) {
      this.showApplicationForm = false;
      this.applicationToEdit = {};
      this.showApplicationTable = true;
    }
  }

  onTableStateChange(state: {viewSelected: string, filters?: any}) {
    this.tableState = state;
  }
}
